import api from '@/api';
import { CreateContactInvitationRequest } from '@/types/api/membership';
import notify from '@/utils/shared/notify';
import { useMutation } from '@tanstack/react-query';

export function useCreateContactInvitationMutation() {
  return useMutation({
    mutationKey: ['create-link-invitation'],
    mutationFn: (data: CreateContactInvitationRequest) => api.membership.invitation.createContact(data),
    onSuccess: (data) => {
      notify.success('Inbjudning skickad');
    },
    onError: (error, variables, context) => {
      notify.error('Inbjudan misslyckades');
    },
  });
}
